import api from './api'

const authService = {
  async login(credentials) {
    const response = await api.post('/auth/login', credentials)
    return response.data
  },

  // Public: { enabled } — SSO tắt thì trang đăng nhập chỉ hiện form tài khoản nội bộ
  async ssoStatus() {
    const response = await api.get('/auth/sso/status')
    return response.data
  },

  async exchangeSso() {
    const response = await api.post('/auth/sso/exchange')
    return response.data
  },

  async logout() {
    try {
      await api.post('/auth/logout')
    } catch {
      // ignore
    }
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
  },

  async getMe() {
    const response = await api.get('/auth/me')
    return response.data
  },

  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    })
    return response.data
  },

  setTokens(accessToken, refreshToken) {
    localStorage.setItem('access_token', accessToken)
    localStorage.setItem('refresh_token', refreshToken)
  },

  setUser(user) {
    localStorage.setItem('user', JSON.stringify(user))
  },

  getStoredUser() {
    const user = localStorage.getItem('user')
    return user ? JSON.parse(user) : null
  },

  isAuthenticated() {
    return !!localStorage.getItem('access_token')
  },
}

export default authService
